import { Action } from '@ngrx/store';
import {
  EmployeeEquipmentWorkflowInterface,
  EquipmentCategoryInterface,
  EquipmentInterface } from 'app/equipment/models';

import { EquipmentActionType } from './equipment-action-type.enum';

export class DeleteEquipmentLibraryCategory implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEquipmentLibraryCategory;

  constructor(public readonly payload: EquipmentCategoryInterface) { }
}

export class DeleteEquipmentLibraryCategoryCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEquipmentLibraryCategoryCompleted;

  constructor(public readonly payload: EquipmentCategoryInterface) { }
}

export class DeleteEquipmentLibraryCategoryFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEquipmentLibraryCategoryFailed;

  constructor(public readonly payload: string) { }
}
export class DeleteEquipmentLibraryItem implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEquipmentLibraryItem;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class DeleteEquipmentLibraryItemCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEquipmentLibraryItemCompleted;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class DeleteEquipmentLibraryItemFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEquipmentLibraryItemFailed;

  constructor(public readonly payload: string) { }
}

export class DeleteEmployeeEquipmentWorkflow implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEmployeeEquipmentWorkflow;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class DeleteEmployeeEquipmentWorkflowCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEmployeeEquipmentWorkflowCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface) { }
}

export class DeleteEmployeeEquipmentWorkflowFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.DeleteEmployeeEquipmentWorkflowFailed;

  constructor(public readonly payload: string) { }
}
